export enum CouponDuration {
  FOREVER = 'forever',
  ONCE = 'once',
  REPEATING = 'repeating',
}
